import { render, staticRenderFns } from "./TrainersDashboard.vue?vue&type=template&id=7d4b4df8"
import script from "./TrainersDashboard.vue?vue&type=script&lang=js"
export * from "./TrainersDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports